import happyFaceAnimation from './data/happyFaceAnimation.lottie';
import { AnimationContainer } from '../../common/AnimationContainer';

export const HappyFace = () => {
  return <AnimationContainer height={200} lottie={happyFaceAnimation} />;
};
